import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { CloseOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';

import Button from 'components/Button/Button';
import { Flex } from 'components/ui/flex';
import { Spinner } from 'components/ui/spinner';

import { EToasterStatus, showToast } from '../../utils/showToast';

import {
  IMPORT_CSV_FILE_DESCRIPTION,
  IMPORT_CSV_FILE_MESSAGE
} from './constants/constants';
import { ImportCSVContentProps } from './types';

import './style.scss';

const ImportCSVContent = ({
  isUploading,
  fileRef,
  setFieldValue
}: ImportCSVContentProps) => {
  const handleFileChange = (event: any) => {
    const file = event.currentTarget.files[0];
    if (file.type !== 'text/csv') {
      showToast({
        message: IMPORT_CSV_FILE_MESSAGE,
        status: EToasterStatus.ERROR
      });
      return;
    }
    setFieldValue('file', file);
  };

  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.type !== 'text/csv') {
        showToast({
          message: IMPORT_CSV_FILE_MESSAGE,
          status: EToasterStatus.ERROR
        });
        return;
      }
      setFieldValue('file', file);
      if (fileRef.current) {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileRef.current.files = dataTransfer.files;
      }
    }
  };

  const handleDragOver = (event: React.DragEvent) => {
    event.preventDefault();
  };

  const handleDragEnter = (event: React.DragEvent) => {
    event.preventDefault();
  };

  const handleDragLeave = (event: React.DragEvent) => {
    event.preventDefault();
  };

  const calculateFileSizeDisplay = (sizeInBytes: number) => {
    const sizeInKB = sizeInBytes / 1024;
    if (sizeInKB < 1024) {
      return sizeInKB.toFixed(2) + ' KB';
    } else {
      const sizeInMB = sizeInKB / 1024;
      return sizeInMB.toFixed(2) + ' MB';
    }
  };

  return (
    <div>
      <div>
        <input
          style={{ display: 'none' }}
          type="file"
          ref={fileRef}
          accept=".csv"
          onChange={handleFileChange}
        />
        <Flex
          justify="center"
          align="center"
          className="relative h-72 bg-[#F4F4F5] border border-[#E4E4E7] rounded-lg gap-2"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
        >
          {isUploading ? (
            <Spinner className="size-12" />
          ) : !!fileRef?.current?.files?.length ? (
            <>
              <CloseOutlined
                className="close-icon"
                style={{
                  width: '16px',
                  height: '16px',
                  backgroundColor: 'transparent'
                }}
                sx={{
                  cursor: 'pointer'
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  if (fileRef.current) {
                    fileRef.current.value = '';
                  }
                  setFieldValue('file', null);
                }}
              />
              <FontAwesomeIcon
                icon="fa-solid fa-file"
                style={{
                  fontSize: '34px',
                  height: '34px',
                  width: '34px',
                  color: '#3F3F46'
                }}
              />
              <div className="file-name">{fileRef?.current?.files[0].name}</div>
              <div className="file-size">
                {calculateFileSizeDisplay(fileRef.current.files[0].size)}
              </div>
            </>
          ) : (
            <div className="flex flex-col gap-8 items-center justify-center">
              <div className="flex flex-col gap-2 items-center justify-center">
                <Typography
                  fontFamily="Inter"
                  color="textSecondary"
                  fontSize="14px"
                >
                  {IMPORT_CSV_FILE_DESCRIPTION}
                </Typography>
              </div>
              <div className="upload-button-container">
                <Button
                  variant="outline"
                  type="button"
                  onClick={() => {
                    fileRef?.current?.click();
                  }}
                  isUploadButton
                  rightIcon={
                    <FontAwesomeIcon
                      icon="fa-regular fa-plus"
                      className="text-sm"
                    />
                  }
                >
                  Upload
                </Button>
              </div>
            </div>
          )}
        </Flex>
      </div>
    </div>
  );
};
export default ImportCSVContent;
